import { Component, inject, OnInit, signal } from '@angular/core';
import { PipesModule } from '@digipay/ng-lib-pipes';

import { ImageComponent } from '../../../../shared/components/image/image.component';
import { PortfolioDetail } from '../../../../data-access/models/portfolio-detail.model';
import { FundDataService } from '../../../../components/core/services/fund-data.service';
import { CROWD_LIST_ROUTE, INVESTMENT_LIST_ROUTE, PORTFO } from '../../../../data-access/constants/app-routes';
import { IUserFundAssets } from '../../../../components/core/models/user-fund-assets.interface';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { FilterPortfoPipe } from '../../pipes/filter-portfo.pipe';
import { ActivatedRoute, Params } from '@angular/router';
import { LocationService } from '../../../../shared/services/location.service';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { DecimalPipe } from '@angular/common';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-portfo-all-profiles',
  standalone: true,
  imports: [ImageComponent, PipesModule, NgxAppBarComponent, DecimalPipe, SpinnerComponent],
  templateUrl: './portfo-all-profiles.component.html',
  styleUrl: './portfo-all-profiles.component.scss',
})
export class PortfoAllProfilesComponent implements OnInit {
  loading = signal(false);
  assetData: PortfolioDetail[];
  params: Params;
  balance = signal<number>(0);
  canSee = signal(true);
  filteredData = signal([]);
  filterPortfo = new FilterPortfoPipe();

  private location = inject(LocationService);
  private navigationService = inject(WealthNavigationService);
  private activatedRoute = inject(ActivatedRoute);
  private fundService = inject(FundDataService);

  onBackHandler() {
    this.navigationService.navigate([PORTFO]);
  }

  goToDetail(item: PortfolioDetail) {
    this.location.saveRoute('/all-profiles');
    switch (item.investmentType) {
      case 'CrowdFund':
        this.navigationService.navigate([CROWD_LIST_ROUTE, item.symbol]);
        break;
      case 'ETF':
        this.navigationService.navigate([INVESTMENT_LIST_ROUTE, item.symbol]);
        break;

      // case 'IPO':
      //   this.navigationService.navigate([IPO_DETAIL_ROUTE], {
      //     queryParams: { id: item.id },
      //   });
      //   break;
      default:
        this.navigationService.navigate([INVESTMENT_LIST_ROUTE, item.symbol]);
        break;
    }
  }

  getFund() {
    this.loading.set(true);
    this.fundService
      .getUserAssets(true)
      .pipe()
      .subscribe({
        next: (value: IUserFundAssets) => {
          this.assetData = value.portfolioDetails;
          const assets = this.filterPortfo.transform(this.assetData);
          const filteredData = [];
          let balance = 0;
          assets[this.params['type']].forEach((asset) => {
            if (asset.price) {
              filteredData.push(asset);
              balance = balance + asset.price;
            }
          });
          this.filteredData.set(filteredData);
          this.balance.set(balance);
        },
        complete: () => {
          this.loading.set(false);
        },
      });
  }

  ngOnInit(): void {
    const validParams = ['ipo', 'crowd', 'fund'];
    this.params = this.activatedRoute.snapshot.queryParams;
    if (!this.params['type'] || !validParams.includes(this.params['type'])) this.navigationService.navigate([PORTFO]);
    this.getFund();
  }

  changeSeeStatus() {
    this.canSee.set(!this.canSee());
  }
}
